import { CircularProgress } from '@material-ui/core';
import MaterialUIButton, { ButtonProps } from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import * as React from 'react';

const FloatingCircularProgress = withStyles({
    root: {
        left: '50%',
        marginLeft: -12,
        marginTop: -12,
        position: 'absolute',
        top: '50%',
    },
})(CircularProgress);

type IButtonProps = ButtonProps & { isLoading?: boolean };

class Button extends React.Component<IButtonProps> {
    public render() {
        const { children, isLoading, ...buttonProps } = this.props;
        return (
            <MaterialUIButton {...buttonProps} disabled={isLoading || buttonProps.disabled}>
                {children}
                {isLoading && <FloatingCircularProgress size={24} />}
            </MaterialUIButton>
        );
    }
}

export default Button;



// WEBPACK FOOTER //
// ./src/common/Button/Button.tsx